// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-PzY","buttons":"styles_buttons__1ui7f"};